"use client";
import CubesImage from '../../../../common/general/cubes-image/CubesImage';
import LinkUrl from '../../../../common/general/link/LinkUrl';
import style from './cartProduct.module.scss';
import { useLocale, useTranslations } from 'next-intl';
import { formatPrice } from '@/projectRoot/src/utils/handlers/productsHandler';
import Input, { InputTypes } from '../../../../common/form-elements/input/Input';
import Button from '../../../../common/form-elements/button/Button';
import Heart from '../../../../common/svg/Heart';
import { QuantityAction, useCart } from '@/projectRoot/src/contexts/CartContext';
import { useProfile } from '@/projectRoot/src/contexts/ProfileContext';
import CartItemDto from '@/projectRoot/api-client/interfaces/models/webshop/cart/CartItem.dto';
import Image from 'next/image';

interface Props {
    item: CartItemDto;
    classes?: string[];
    withoutActions?: boolean;
}

const CartProduct = ({item, classes = [], withoutActions = false}: Props) => {
    const locale = useLocale();
    const t = useTranslations();
    const {cartDispatchAction} = useCart();
    const {identity, updateWishlist} = useProfile();
    const product = item.product;

    const onIncrement = () => {
        if(item.quantity == +item.meta.available_stock) return;
        cartDispatchAction({type: 'handleProductQuantity', payload: {type: QuantityAction.ADD, product_id: item.product_id, stock_variant: item.meta.stock_variant, quantity: 1}})
    }
  return (
    <article className={`${style.cartProduct} ${classes.join(' ')}`}>
      <LinkUrl url={withoutActions ? '#' : product.multilang_slugs[locale]} classes={[style.image, 'imgPlaceholder']} noLink={withoutActions}>
        {
            product.image_url.length == 0
            ?
            <Image src={'/img/placeholder/product-placeholder.png'} alt={product.title} width={266} height={400} />
            :
            <CubesImage imageNarrow={product.image_url} alt={product.title} />
        }
      </LinkUrl>
      <div className={style.info}>
        <div className={style.upperPart}>
            <LinkUrl url={withoutActions ? '#' : product.multilang_slugs[locale]} text={product.title + (withoutActions ? (item.quantity > 1 ? ` (${item.quantity}x)` : '') : '')} classes={[style.title]} noLink={withoutActions} />
            <p className={style.prices}>
                <span className={`${style.price} ${product.base_price !== product.price ? style.anotherPrice : ''}`}>
                    {formatPrice(product.base_price)} {process.env.NEXT_PUBLIC_CURRENCY}
                </span>
                {
                    product.base_price !== product.price
                    ?
                    <span className={style.discountPrice}>
                        {formatPrice(product.price)} {process.env.NEXT_PUBLIC_CURRENCY}
                    </span>
                    : <></>
                }
            </p>
        </div>
        <p className={style.sizeColorWrapper}>
            <span>
                {t('size')}: {item.meta.stock_variant}
            </span>
            <span>
                {t('color')}: {product.color.title}
            </span>
        </p>
        {
            !withoutActions
            ?
            <div className={style.quantityWrapper}>
                <span className={style.minus} onClick={() => cartDispatchAction({type: 'handleProductQuantity', payload: {type: QuantityAction.REMOVE, product_id: item.product_id, stock_variant: item.meta.stock_variant, quantity: 1}})}>
                    -
                </span>
                <Input value={item.quantity} type={InputTypes.NUMBER} classes={[style.input]} onInput={(e) => cartDispatchAction({type: 'handleProductQuantity', payload: {type: QuantityAction.INPUT, product_id: item.product_id, quantity: +e.currentTarget.value, stock_variant: item.meta.stock_variant}})} />
                <span className={style.plus} onClick={onIncrement}>
                    +
                </span>
            </div>
            : <></>
        }
      </div>
      {
        !withoutActions
        ?
        <div className={style.rightPart}>
            {
                identity
                ?
                <Button label='wishlist icon' classes={[style.wishlistBtn]} onClick={() => updateWishlist([item.product_id])}>
                    <Heart width={15} height={15} fill={identity && identity.wishlist_ids && identity.wishlist_ids.includes(item.product_id)} />
                </Button>
                : <></>
            }
            <span className={style.removeAction} onClick={() => cartDispatchAction({type: 'removeProduct', payload: {product_id: item.product_id, stock_variant: item.meta.stock_variant}})}>
                {t('remove')}
            </span>
        </div>
        : <></>
      }
    </article>
  )
};

export default CartProduct;
